module.exports = __webpack_public_path__ + "img/mob1.f707fde6.png";